import * as zod from 'zod';

export const CustomIOState = zod.object({
  kind: zod.literal('CustomIO'),
});

export type CustomIOState = zod.infer<typeof CustomIOState>;
